// extracted by mini-css-extract-plugin
export default {"notificationContainer":"styles_notificationContainer__B75+M","icon":"styles_icon__I8RyL","notification":"styles_notification__ihPh2","body":"styles_body__O+syK"};